import { find, filter, castArray, isPlainObject } from 'lodash';

import decodeString from 'hb-react/shared/utils/decodeString';

export const getSelectedOptions = ({
  selectedValue,
  isControlled,
  options = [],
  multiple,
  creatable,
}) => {
  if (!selectedValue) {
    return isControlled ? null : undefined;
  }

  if (multiple) {
    const selectedValueAsArray = castArray(selectedValue).filter(Boolean);

    if (creatable) {
      return selectedValueAsArray.map(
        (selectedValue) =>
          options.find(({ value }) => selectedValue === value) ?? {
            label: selectedValue,
            value: selectedValue,
          },
      );
    }

    return filter(
      options,
      ({ value, id }) =>
        selectedValueAsArray.includes(value) ||
        selectedValueAsArray.includes(id),
    );
  }

  const match = find(
    options,
    ({ value, id }) => value === selectedValue || id === selectedValue,
  );

  if (creatable) {
    return (
      match || {
        label: selectedValue,
        value: selectedValue,
      }
    );
  }

  return match;
};

export const getOptionLabel = ({ label, name, text, title }) =>
  decodeString(label || name || text || title);

export const getOptionValue = ({ value, id }) => value || id;

export const formatOptions = ({ options }) => {
  if (isPlainObject(options)) {
    // Options is an object
    return Object.keys(options).map((optionKeyValue) => ({
      value: optionKeyValue,
      label: decodeString(options[optionKeyValue]),
    }));
  }

  // Options is an array
  return options.map((option) => {
    // Options is an array of strings
    if (!isPlainObject(option)) {
      return {
        value: option,
        label: decodeString(option),
      };
    }

    // Options is an array of objects
    return decodeString(option);
  });
};
